const LOGO_WHITE = "/sbgwc-logo-white.png";
const GIRL = "/sbg-girl.png";

const STEPS = [
  ["Pick your issues", "var(--dream-aqua)"],
  ["Learn the facts", "var(--joy-yellow)"],
  ["Make your pledge", "var(--radiant-fuchsia)"],
  ["Call on voters", "var(--blush)"],
];

export default function WelcomeScreen({ active, onStart }) {
  return (
    <div className={`screen ${active ? "active" : ""}`} id="screen-welcome">
      <div className="welcome-left">
        <img className="welcome-logo" src={LOGO_WHITE} alt="Southern Black Girls and Women's Consortium" />
        <div className="eyebrow">A Youth Voice Campaign</div>
        <h1 className="welcome-title">Vote for Me<span>Until I Can.</span></h1>
        <p className="welcome-subtitle">You have a voice even before you have a vote. Tell the world what matters to you and ask adults to vote on your behalf.</p>
        <div className="welcome-steps">
          {STEPS.map(([label, color]) => (
            <div className="step-chip" key={label}><span className="dot" style={{ background: color }} /> {label}</div>
          ))}
        </div>
        <button className="btn-primary" style={{ alignSelf: "flex-start" }} onClick={onStart} data-testid="hero-start-campaign-btn">Start My Journey →</button>
      </div>
      <div className="welcome-right"><img src={GIRL} alt="Vote for Me Until I Can" /></div>
    </div>
  );
}
